export default "__VITE_ASSET__DOArvTLr__"